<mat-nav-list class="side-navnar">
  @for (menu of headerService.navItems; track menu; let i = $index) {
    <ng-container
      [ngTemplateOutlet]="
        menu.subItems && menu.subItems.length > 0
          ? multiLevelMenu
          : singleLevelMenu
      "
      [ngTemplateOutletContext]="{ menu: menu }">
    </ng-container>
  }
</mat-nav-list>

<ng-template #singleLevelMenu let-menu="menu">
  <mat-list-item
    mat-list-item
    class="parent-item"
    [ngClass]="{ active: headerService.isRouteActive(menu.value) }">
    <a
      (click)="onSideNavLinkClick()"
      routerLinkActive="active"
      [routerLink]="
        $safeNavigationMigration(menu?.value) | translateRouterLink
      ">
      <span class="nav-caption">{{
        $safeNavigationMigration(menu?.label) | translate
      }}</span>
    </a>
  </mat-list-item>
</ng-template>

<ng-template #multiLevelMenu let-menu="menu">
  <mat-expansion-panel
    [class.mat-elevation-z0]="true"
    [ngClass]="{ active: headerService.isRouteActive(menu.value) }">
    <mat-expansion-panel-header>
      {{ menu.label | translate }}
    </mat-expansion-panel-header>
    <mat-nav-list class="nav-list-subItems">
      @for (item of menu.subItems; track item) {
        @if (
          (!item?.hideWhenLogin && headerService.isUserLogin) ||
          !headerService.isUserLogin
        ) {
          <div [ngClass]="{ active: headerService.isRouteActive(item.value) }">
            <!-- External sub link -->
            @if (item?.externalLink) {
              <a
                mat-list-item
                class="{{ item?.customClass }}"
                href="{{ item?.externalLink }}">
                @if (item.icon) {
                  <span class="image-wrapper"
                    ><img [src]="item.icon" alt=""
                  /></span>
                }
                @if (item.icon) {
                  <mat-divider [vertical]="true"></mat-divider>
                }
                <span>{{
                  $safeNavigationMigration(item?.label) | translate
                }}</span>
                <span class="visually-hidden"> (external)</span>
              </a>
            }
            <!-- Internal sub link -->
            @if (!item?.externalLink && item.value !== '/') {
              <a
                mat-list-item
                class="{{ item?.customClass }}"
                (click)="onSideNavLinkClick()"
                [routerLink]="item.value | translateRouterLink"
                routerLinkActive="active">
                @if (item.icon) {
                  <span class="image-wrapper"
                    ><img [src]="item.icon" alt=""
                  /></span>
                }
                @if (item.icon) {
                  <mat-divider [vertical]="true"></mat-divider>
                }
                <span>{{
                  $safeNavigationMigration(item?.label) | translate
                }}</span>
              </a>
            }
            <!-- Internal button: Interactive under Portals -->
            @if (item.length > 0 && !item?.externalLink && item.value === '/') {
              <button
                mat-list-item
                matIconButton
                (click)="onSideNavLinkClick(); headerService.onLoginBtnClick()">
                @if (item.icon) {
                  <span class="image-wrapper"
                    ><img [src]="item.icon" alt=""
                  /></span>
                }
                @if (item.icon) {
                  <mat-divider [vertical]="true"></mat-divider>
                }
                {{ $safeNavigationMigration(item?.label) | translate }}
              </button>
            }
          </div>
        }
      }
    </mat-nav-list>
  </mat-expansion-panel>
</ng-template>
